<template>
  <!-- 支付结果页失败引导气泡 -->
  <agent-tip-frame
    :tip-style="tipStyle"
    :assistant-name="assistantName"
    @close="$emit('close')"
  >
    <template #message>{{ message }}</template>
    <template #actions>
      <button type="button" class="btn-gotit" @click.stop="$emit('primary')">
        {{ primaryLabel }}
      </button>
      <button
        v-if="secondaryLabel"
        type="button"
        class="btn-quiet"
        @click.stop="$emit('secondary')"
      >
        {{ secondaryLabel }}
      </button>
    </template>
  </agent-tip-frame>
</template>

<script>
import AgentTipFrame from './AgentTipFrame.vue';

/**
 * PayFailTip — 支付失败结果页 agent-tip
 * 主按钮在上（btn-gotit），辅助按钮在下（btn-quiet，可选）
 */
export default {
  name: 'PayFailTip',
  components: { AgentTipFrame },
  props: {
    tipStyle: {
      type: Object,
      default: () => ({})
    },
    assistantName: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    primaryLabel: {
      type: String,
      default: ''
    },
    secondaryLabel: {
      type: String,
      default: ''
    }
  }
};
</script>
